import React from 'react'
import { ButtonContainer, MessageContainer, TextContainer, ModalContainer } from './styled'
import { Button } from '../ui/button'
import { FormText } from '../ui/form'
import useIsMobile from '../../hooks/useIsMobile'
import { CheckCircle, Info } from '../../assets/icons'
import { Text2 } from '../ui/text'
import theme from '../../styled/theme'

const Feedback = ({
	title = '',
	bodyText = '',
	isSucces = true,
	isError,
	icon,
	secondaryButtonLabel,
	secondaryButtonIcon,
	haveButton = true,
	buttonLabel = 'Volver',
	onClickSecondaryButton,
	onClickButton,
	isModal=false,
	pt,
	widthDesktop,
	textGap
}) => {
	const isMobile = useIsMobile()
	
	return (
		<ModalContainer isFullHeight={isModal && isMobile} pt={pt}>
			<MessageContainer>
				<TextContainer widthDesktop={widthDesktop} gap={textGap}>
					{icon || (isSucces && !isError && <CheckCircle />) || (isError && <Info />)}
					<FormText font={24} fw={600}>
						{title}
					</FormText>
					{bodyText && (
						<Text2 align="center" color={theme.colors.text.secondaryText} font={18} fw={600}>
							{bodyText}
						</Text2>
					)}
				</TextContainer>
				<ButtonContainer>
					{haveButton && (
						<Button label={buttonLabel} $variant="primary" size={isModal ? 'medium' : 'xlarge'} onClick={onClickButton} />
					)}
					{secondaryButtonLabel && (
						<Button
							label={secondaryButtonLabel}
							$variant="tertiary"
							size={isModal ? 'medium' : 'xlarge'}
							onClick={onClickSecondaryButton}
							$underline={true}
							iconLeft={secondaryButtonIcon}
						/>
					)}
				</ButtonContainer>
			</MessageContainer>
		</ModalContainer>
	)
}

export default Feedback
